import React from "react";

export default function Privacy() {
  return (
    <div style={{ maxWidth: 900, margin: "130px auto 40px", padding: "0 20px" }}>
      <h1 style={{ marginBottom: 16 }}>Privacy Policy</h1>

      <h2>Who we are</h2>
      <p>
        GraduationScope provides tools that help students plan classes and track progress.
        This policy explains how we collect, use, and share information when you use
        graduationscope.com and related services.
      </p>

      <h2>Information we collect</h2>
      <ul>
        <li>
          <strong>a. You provide it.</strong> Account details such as name, email, school, and preferences.
        </li>
        <li>
          <strong>b. Automatically collected.</strong> Device and browser data, IP address, pages viewed,
          referring URL, and general location derived from IP.
        </li>
        <li>
          <strong>c. Cookies and similar tech.</strong> We use cookies to remember settings, measure usage, and show ads.
        </li>
        <li>
          <strong>d. Communications.</strong> Messages you send to us, feedback, and support requests.
        </li>
      </ul>

      <h2>How we use information</h2>
      <p>
        Provide and improve the service, personalize features, measure performance, show and measure
        advertising, prevent fraud and abuse, and communicate with you about updates or support.
      </p>

      <h2>Legal bases for users in the EEA and UK</h2>
      <p>
        We process data to perform a contract, with your consent, to meet legal obligations, and for our
        legitimate interests such as improving the service and keeping it secure. You can withdraw consent at any time.
      </p>

      <h2>Advertising and Google AdSense</h2>
      <p>
        Third-party vendors, including Google, use cookies to serve ads based on prior visits to this or other
        sites. Google’s use of advertising cookies enables it and its partners to serve ads to you.
      </p>
      <ul>
        <li>
          You can opt out of personalized ads in Google Ads Settings:{" "}
          <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer">
            https://adssettings.google.com
          </a>.
        </li>
        <li>
          You can opt out of some third-party vendor cookies at{" "}
          <a href="https://www.aboutads.info/choices" target="_blank" rel="noopener noreferrer">
            https://www.aboutads.info/choices
          </a>.
        </li>
        <li>
          Learn how Google uses information from partner sites:{" "}
          <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer">
            https://policies.google.com/technologies/partner-sites
          </a>.
        </li>
      </ul>

      <h2>Analytics</h2>
      <p>
        We may use analytics tools that set cookies and collect usage data to help us understand how the site
        is used and to improve it.
      </p>

      <h2>Sharing information</h2>
      <p>
        We share information with service providers that help us run the site, with advertising and analytics
        partners, to comply with law or protect rights, and during a merger, acquisition, or asset sale. We do
        not sell personal information for money.
      </p>

      <h2>Retention</h2>
      <p>
        We keep information only as long as needed for the purposes above and to meet legal requirements.
      </p>

      <h2>Your choices and rights</h2>
      <p>
        You can access, correct, or delete your information by contacting us. You can opt out of marketing emails
        via the unsubscribe link. California residents have rights to know, delete, correct, and opt out of the
        “sale” or “sharing” of personal information. EEA and UK residents may request access, correction, deletion,
        restriction, portability, and objection.
      </p>

      <h2>Children’s privacy</h2>
      <p>
        Our services are for students in higher education and are not directed to children under 13. We do not
        knowingly collect information from children under 13.
      </p>

      <h2>International transfers</h2>
      <p>
        If we transfer data outside your region, we use reasonable safeguards consistent with applicable law.
      </p>

      <h2>Security</h2>
      <p>
        We use reasonable technical and organizational measures to protect information. No method is perfectly secure.
      </p>

      <h2>Changes</h2>
      <p>
        We may update this policy. We will change the “Effective date” above and post the new version.
      </p>

      <h2>Contact</h2>
      <p>
        Email: <a href="mailto:eli9keys@gmail.com">eli9keys@gmail.com</a>
        <br />
        Mail: Graduation Scope, 3705 Gibbons Parkway
      </p>
    </div>
  );
}
